<template lang="">
    <div class="notice-page">
        <Notification />
    </div>
</template>

<script>
import Notification from '../../components/Web/Notification';

export default {
    components: {
        Notification,
    },
};
</script>

<style scoped lang="scss">
.notice-page {
    width: 100%;
    max-width: 1170px;
    padding: 0 15px;
    margin: 40px auto;
}
</style>
